import React, { useEffect } from 'react'
import { Link } from "react-router-dom";

import NavBar from '../Common/Navbar'
import FooterMenu from '../Common/FooterMenu';
import Copyright from '../Common/Copyright';
import TopButton from '../Home/TopButton';

function Testimonials() {
    useEffect(() => {
        window.scrollTo(0, 0);
      }, []);
    return (
        <>
            <div className='header-about'>
                <NavBar />
                <div className="container text-center cont-sec">
                    <h2>Testimonials</h2>
                    <div className="d-flex align-items-center justify-content-center">
                        <Link to = "/">Home</Link>
                        <span>//</span>
                        <Link to = "/testimonial">Testimonials</Link>
                    </div>
                </div>
            </div>
            <div id="testimonial" className='d-flex flex-column'>
                <div className="container text-center">
                    <h3>What Our Client Says</h3>
                    <div className="testimonial-slider">
                        <div className='testimon d-flex align-items-center flex-column text-center'>
                            <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type.</p>
                            <h5>Henry Koch</h5>
                            <h6>Brand Owner</h6>
                        </div>
                    </div>
                </div>
                <div className="container text-center">
                    <h3>What Our Client Says</h3>
                    <div className="testimonial-slider">
                        <div className='testimon d-flex align-items-center flex-column text-center'>
                            <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type.</p>
                            <h5>Henry Koch</h5>
                            <h6>Brand Owner</h6>
                        </div>
                    </div>
                </div>
                <div className="container text-center">
                    <h3>What Our Client Says</h3>
                    <div className="testimonial-slider">
                        <div className='testimon d-flex align-items-center flex-column text-center'>
                            <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type.</p>
                            <h5>Henry Koch</h5>
                            <h6>Brand Owner</h6>
                        </div>
                    </div>
                </div>
            </div>
            <FooterMenu />
            <Copyright />
            <TopButton />
        </>
    )
}

export default Testimonials
